import { Bar } from "recharts";

const BaseBar = Bar

export default BaseBar